var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredWebIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5606 3.87563C9.52304 4.46918 7.71164 5.66308 6.36276 7.30156C5.01387 8.94005 4.19014 10.947 3.99902 13.0607H8.81822C9.09914 9.84428 10.0317 6.71865 11.5591 3.87412L11.5606 3.87563ZM8.81822 14.9432H3.99902C4.18974 17.057 5.01312 19.0642 6.36174 20.7029C7.71036 22.3417 9.5216 23.5359 11.5591 24.1298C10.0317 21.2853 9.09914 18.1597 8.81822 14.9432ZM13.9748 24.5319C12.1489 21.636 11.0294 18.3514 10.7067 14.9432H18.2895C17.9668 18.3514 16.8473 21.636 15.0214 24.5319C14.6728 24.5492 14.3234 24.5492 13.9748 24.5319ZM17.4386 24.1283C19.4759 23.5345 21.287 22.3405 22.6356 20.702C23.9842 19.0636 24.8077 17.0567 24.9987 14.9432H20.1795C19.8986 18.1597 18.966 21.2853 17.4386 24.1298V24.1283ZM20.1795 13.0607H24.9987C24.808 10.947 23.9846 8.93978 22.636 7.30102C21.2873 5.66226 19.4761 4.46802 17.4386 3.87412C18.966 6.71865 19.8986 9.84428 20.1795 13.0607ZM13.9748 3.47202C14.3239 3.45464 14.6738 3.45464 15.0229 3.47202C16.8483 6.36803 17.9673 9.65263 18.2895 13.0607H10.7083C11.0351 9.63156 12.157 6.34396 13.9748 3.47202Z",
    fill: "#00C13A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredWebIcon);
export default __webpack_public_path__ + "static/media/colored_web_icon.1aee8ed94e2e3d8668a917051db43d9f.svg";
export { ForwardRef as ReactComponent };